/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Style_LabelInputs */



/**
* | output |
* | --- |
* | "Style" |
*
* @param {Paste_Attributes_Style_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_style_label = /** @type {((inputs?: Paste_Attributes_Style_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Style_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стиль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("风格")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शैली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estilo")
	return /** @type {LocalizedString} */ ("Style")
});